<template>
    
            <v-card outlined shaped>
                <div id="reportGrid" v-if="!printVisible" >
                <v-card-title>
                    Leak Test Report
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details=""
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <vue-excel-xlsx
                                :data="leakTestReportdata"
                                :columns="headersExport"
                                :file-name="fileName"
                                :file-type="'xlsx'"
                                :sheet-name="'sheetname'">
                                <v-btn color="blue-grey" class="ma-2 white--text">
                                    Export
                                    <v-icon right dark>mdi-cloud-download</v-icon>
                                </v-btn>
                            </vue-excel-xlsx>
                        </v-col>
                        <v-col cols="2">
                           <!--<a :href="`/reports/leaktestreportprint`" ><v-icon aria-hidden="false">mdi-printer-eye</v-icon></a>-->
                           <v-btn color="success" class="ma-2 white--text" @click="printPreview"> Preview<v-icon aria-hidden="false">mdi-printer-eye</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    

                </v-card-text>
                    
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="leakTestReportdata"
                        :search="search"
                        :items-per-page="10"
                        @current-items="getFiltered"
                        disable-pagination
                        hide-default-footer
                        class="elevation-1">  

                                <template v-slot:item.secure="{ item }">
                                    <v-text-field v-model="item.secure" ></v-text-field> 
                                </template>
                                <template v-slot:item.sign="{item}">
                                    <v-text-field v-model="item.sign" ></v-text-field>
                                </template>
                                <template v-slot:item.name="{item}">
                                    <v-text-field v-model="item.name" ></v-text-field>
                                </template>
                                <template v-slot:item.date="{item}">
                                    <v-text-field v-model="item.date" ></v-text-field>
                                </template>  
                    </v-data-table>
                    
                </v-card-text>
                </div>

                <div v-if="printVisible">
                    <LeakTestReportPrint :filterTestitems="leakTestReportdata" :printVisible="true" @clicked="onClickChild" ></LeakTestReportPrint>
                </div>
                
            </v-card>
        
            
    
</template>

<script>
    
    import reportsAPI from '@/services/reportsservice';
    import moment from 'moment';
    import LeakTestReportPrint from './LeakTestReportPrint.vue';
    export default {
        name:'LeakTestReport',
        data:function(){
            return {
                search:'',
                printVisible: false,
                fileName: 'LeakTestReport'+moment(Date.now()).format('YYYY-MM-DD'),
                leakTestReportdata:[],
                filteredTestReport:[]
            }
        },
        computed:{
            headers(){
                return [
                    { text: 'Serial Number ' , align: 'start', sortable:true, value: 'serial'},
                    { text: 'Building', align:'start', sortable:true, value: 'building'},
                    { text: 'Floor', align:'start', sortable: true, value: 'floor'},
                    { text: 'Location', align:'start', sortable:true, value: 'location'},
                    { text: 'Leak Test Group', align: 'start', sortable: true, value:'leakTestGroup'},
                    //{ text: 'holder', align: 'start' , sortable:true, value: 'holder'},
                    //{ text: 'Ref', align: 'start', sortable:true, value: 'ref'},
                    //{ text: 'Last Device Check', align:'start',sortable: true, value:'lastCheck'},
                    { text: 'Secure Y/N', align: 'start', sortable: true, value: 'secure'},
                    { text: 'Caution Sign', align: 'start', sortable: true, value: 'sign'},
                    { text: 'Name', align: 'start', sortable: true, value: 'name'},
                    { text: 'Date', align: 'start', sortable: true, value: 'date'}

                ]
            },
            headersExport(){
                 return [
                    { label:'Serial Number',  field:'serial'},
                    { label:'Building',  field:'building'},
                    { label:'Floor',  field:'floor'},
                    { label:'Location',  field:'location'},
                    { label: 'Leak Test Group', field: 'leakTestGroup'},
                    //{ label:'Holder',  field:'holder'},
                    //{ label:'Ref',  field:'ref'},
                    //{ label: 'Last Check', field:'lastCheck'},
                    { label:'Secure',  field:'secure'},
                    { label:'Sign',  field:'sign'},
                    { label:'Name',  field:'name'},
                    { label:'Date',  field:'date'}
                 ]
            }
        },
        methods:{
            async loadReport(){
                await reportsAPI.getLeakTestReport()
                .then(response=>{this.leakTestReportdata=response.data})
                .catch(error=>{console.log(error)});
            },
            async printPreview(){
                this.printVisible=true;
            },
            onClickChild(value){
                console.log(value);
                this.printVisible=value;
            },
             getFiltered(e){
                //console.log('Filtered');
                //console.log(e[0]) //output the filtered items
                this.filteredTestReport=e;
            },
            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            parseDate (date) {    
                    if (!date) return null;

                    const [month, day, year] = date.split('/')
                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
                }
        },
        mounted:function(){
            this.loadReport();
        },
        components:{
            LeakTestReportPrint
        }
    
    }
</script>

